module.exports = __webpack_public_path__ + "static/media/about_pollination.b5bb9f71.jpg";